<template>
  <div class="icons icons--inline" v-if="schema.showActions && schema.fieldId">
    <button
      class="icon-button"
      @click="alterPosition(schema.fieldId, schema.fieldPosition - 1)"
      v-if="!schema.firstField">
        <i class="material-icons">arrow_upward</i>
    </button>
    <button
      class="icon-button"
      @click="alterPosition(schema.fieldId, schema.fieldPosition + 1)"
      v-if="!schema.lastField">
        <i class="material-icons">arrow_downward</i>
    </button>
    <router-link :to="{ name: 'admin-edit-field', params: { fieldId: schema.fieldId, pageId: schema.pageId } }"><i class="material-icons">mode_edit</i></router-link>
    <button class="icon-button " @click="deleteField"><i class="material-icons">delete</i></button>
  </div>
</template>

<script>
  export default {
    props: ['schema'],

    methods: {
      deleteField() {
        /* eslint-disable no-alert */
        if (confirm(
          `Are you sure you want to delete ${this.schema.label}?`)) {
          this.$store.dispatch('admin/deleteField', { pageId: this.schema.pageId, fieldId: this.schema.fieldId });
        }
      },

      alterPosition(fieldId, position) {
        this.$store.dispatch('admin/editField', { data: { id: fieldId, position }, noCommit: true })
          .then(() => this.$store.dispatch('admin/fetchFields', this.schema.pageId));
      },
    },
  };
</script>
